import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_dashboard/mail/')({
  beforeLoad: () => {
    throw redirect({ to: '/mail/$folder', params: { folder: 'INBOX' } });
  },
});
